import { render, staticRenderFns } from "./cardcollapseSubs.vue?vue&type=template&id=4b835f71&scoped=true"
import script from "./cardcollapseSubs.vue?vue&type=script&lang=js"
export * from "./cardcollapseSubs.vue?vue&type=script&lang=js"
import style0 from "./cardcollapseSubs.vue?vue&type=style&index=0&id=4b835f71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b835f71",
  null
  
)

export default component.exports